import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getPlanList = store => store[NAME].planList;
export const getBenefitList = store => store[NAME].benefitList;